import { FC, useContext } from "react";
import { MasterContext } from "../../lib/masterContext";

export const LogoCircle: FC = () => {
  const { flavor } = useContext(MasterContext);

  return flavor.getCircleLogo();
};
